import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useGlobalContext } from '../stores/global';

export type Props = {
  show?: boolean;
  useGlobalLoading?: boolean;
};

export default function GlobalLoading({ show, useGlobalLoading }: Props) {
  const { isLoading } = useGlobalContext();

  return (
    <div
      style={{
        display: show || (useGlobalLoading && isLoading) ? 'flex' : 'none',
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0, 0, 0,0.5)',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </div>
  );
}
